<app-create-employee
	[label]="label + ' employee'"
	checkboxLabel="Same as law firm"
	[firm]="lawFirm"
	[employee]="role === 'lawyer' ? lawFirm?.lawyer : lawFirm?.clerk"
	[firstName]="_firstName"
	[lastName]="_lastName"
	[required]="required"
	(onSubmit)="onSubmit($event)"
>
</app-create-employee>
